export enum ProductImportStatus {
    Indeterminate = 0,
    Imported = 1,
    Published = 2,
    Rejected = 3,
}

